<!-- Footer -->
<p class="clearfix mb-0">

    <span class="float-md-right d-none d-md-block">
BuyHelp @ 2024<span [data-feather]="'heart'" [class]="'pink'"></span>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>
